import { motion } from "framer-motion";

/**
 * Light-theme background FX:
 *  - Warm off-white base
 *  - Faint dot grid
 *  - Soft navy glows top-left / bottom-right
 */
export const BackgroundFX = () => {
  return (
    <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden">
      <div className="absolute inset-0 bg-[#F7F6F3]" />

      {/* Grid pattern */}
      <div
        className="absolute inset-0 opacity-[0.5]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(19,98,7,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(19,98,7,0.05) 1px, transparent 1px)",
          backgroundSize: "72px 72px",
          maskImage:
            "radial-gradient(ellipse at center, black 30%, transparent 85%)",
          WebkitMaskImage:
            "radial-gradient(ellipse at center, black 30%, transparent 85%)",
        }}
      />

      {/* Top-left navy glow */}
      <motion.div
        aria-hidden
        initial={{ opacity: 0.55 }}
        animate={{ opacity: [0.45, 0.7, 0.45] }}
        transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
        className="absolute -top-[20vh] -left-[15vw] w-[70vw] h-[70vw] max-w-[1100px] max-h-[1100px] rounded-full"
        style={{
          background:
            "radial-gradient(circle at center, rgba(19,98,7,0.10) 0%, rgba(19,98,7,0.04) 30%, rgba(19,98,7,0) 65%)",
          filter: "blur(50px)",
        }}
      />

      {/* Bottom-right warm glow */}
      <motion.div
        aria-hidden
        initial={{ opacity: 0.5 }}
        animate={{ opacity: [0.4, 0.65, 0.4] }}
        transition={{ duration: 12, repeat: Infinity, ease: "easeInOut", delay: 1 }}
        className="absolute -bottom-[20vh] -right-[15vw] w-[70vw] h-[70vw] max-w-[1100px] max-h-[1100px] rounded-full"
        style={{
          background:
            "radial-gradient(circle at center, rgba(19,98,7,0.07) 0%, rgba(19,98,7,0) 60%)",
          filter: "blur(60px)",
        }}
      />

      {/* Soft edge fades */}
      <div className="absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-[#F7F6F3] to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-[#F7F6F3] to-transparent" />
    </div>
  );
};

export default BackgroundFX;
